import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { transformStr3, handleHttp, getformListItemsdatas, colorConfig } from "@/utils/utils";
export default {
  data() {
    return {
      params: {
        deptId: this.$route.query.fid,
        formId: '595257',
        page: 1,
        limit: 10,
        searchStr: ''
      },
      themebg: require('../assets/audioGuide/topbg.jpg')
    };
  },
  created() {
    this.getTheme();
  },
  methods: {
    // 获取讲解主题设置表单数据
    getTheme() {
      this.$api.singleadvanceSearch(this.params).then(res => {
        if (!res.totalRow) return;
        res.dataList.forEach((item, index) => {
          let itemformdata = item.formIdValueData;
          let itemformat = {};
          Object.keys(itemformdata).forEach(key => {
            itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
          });
          item.itemformdata = itemformat;
        });
        let tconfig = res.dataList[0].itemformdata;
        if (tconfig.title) document.title = tconfig.title;
        if (tconfig.color.length) colorConfig(tconfig.color, '--audio-theme');
        if (tconfig['23'] && tconfig['23'].length) colorConfig(tconfig['23'], '--audio-bg-theme');
        if (tconfig['24'] && tconfig['24'].length) this.themebg = handleHttp(tconfig['24'][0].fileUrl);
      });
    }
  }
};